import {
	Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy,
	ViewChild
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { UntypedFormBuilder, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { SchedDiscConfigComponentBase } from "../SchedDiscConfigComponentBase";
import { NetFacadeService } from 'netview';
import { HaloExport } from 'DiscoveryEngine.TS/Export/HaloExport';
import { HaloExportConfigComponent } from '../halo-export-config/halo-export-config.component';

@Component({
	selector: 'sched-disc-config-halo',
	templateUrl: './sched-disc-config-halo.component.html',
	styleUrls: ['./sched-disc-config-halo.component.scss']
})
export class SchedDiscConfigHaloComponent extends SchedDiscConfigComponentBase {

	@ViewChild(HaloExportConfigComponent, { static: true })
	private HaloExportComp: HaloExportConfigComponent;

	private static NullHaloExport = new HaloExport();

	public get HaloExport(): HaloExport {
		if (this.Discovery)
			return this.Discovery.HaloExport;
		else
			return SchedDiscConfigHaloComponent.NullHaloExport;
	}

	constructor(private fb: UntypedFormBuilder, netFacadeService: NetFacadeService) {
		super(netFacadeService);
	}

	protected BuildForm(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.onChanges();
	}

	public get tempChanges(): boolean {
		return this.HaloExportComp.tempChanges;
	}

	public get tempChangesValid(): boolean {
		return this.HaloExportComp.tempChangesValid;
	}

	public applyTempChanges(): void {
		this.HaloExportComp.applyTempChanges();
		this.onApplyTempChanges();
	}

	public get invalidTempChanges(): string[] {
		return this.HaloExportComp.invalidTempChanges;
	}

	public discardTempChanges(): void {
		this.HaloExportComp.discardTempChanges();
	}

}
